// Third party
import React, { useEffect } from 'react';

// Namespace
import * as ProposalNS from '../../Proposal';

// Utils
import { getSidebarNavigationTabs } from '@/modules/proposal/ProposalHelpers';

// Constant and types
import User from '@/types/user';

// Components
import DownloadPDFButton from './DownloadPDFButton';
import TabNavigation from './TabNavigation';

type Props = {
  user: User;
  template: ProposalNS.ProposalTemplateV2;
  setSidebarToDisplay: (sidebarTab: ProposalNS.ProposalSidebarTab | undefined) => void;
  setShowAddContentButton: (show: boolean) => void;
  downloadPdf?: () => void;
};

const NavigationHeader = (props: Props) => {
  const [selectedSidebarTab, setSelectedSidebarTab] = React.useState<string>();

  // When the template changes, select the first tab
  useEffect(() => {
    if (props.template.sidebarTabs.length > 0) {
      setSelectedSidebarTab(props.template.sidebarTabs[0].key);
    } else {
      setSelectedSidebarTab(undefined);
    }
  }, [props.template.sidebarTabs]);

  // When the selected tab changes, update the sidebar to display
  useEffect(() => {
    if (selectedSidebarTab) {
      const sidebarTab = props.template.sidebarTabs.find(tab => tab.key === selectedSidebarTab);
      props.setSidebarToDisplay(sidebarTab);
      // if the selected tab is the first option
      if (selectedSidebarTab === props.template.sidebarTabs[0].key) {
        props.setShowAddContentButton(true);
      }
    } else {
      props.setSidebarToDisplay(undefined);
      props.setShowAddContentButton(false);
    }
  }, [props, props.template.sidebarTabs, selectedSidebarTab]);

  const onTabChange = (tab: string | undefined) => {
    if (!tab) {
      return;
    }

    const selectedTab = props.template.sidebarTabs.find(element => element.key === tab);
    selectedTab === props.template.sidebarTabs[0] ? props.setShowAddContentButton(true) : props.setShowAddContentButton(false);
    setSelectedSidebarTab(selectedTab ? selectedTab.key : undefined);
  };

  return (
    <nav className="proposal-toolbox-nav">
      <DownloadPDFButton user={props.user} downloadPdf={props.downloadPdf} />
      <TabNavigation sidebarTabs={getSidebarNavigationTabs(props.user, props.template)} selectedSidebarTab={selectedSidebarTab} onTabChange={onTabChange} />
    </nav>
  );
};

export default NavigationHeader;
